import React, { useRef, useState } from "react";
import useButtonLoader from "hooks/useButtonLoader";
import OTPInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { resendOtp, verifyOtpApi } from "services/auth";
import { toastMessage } from "utils/toastMessage";
import useResendOtp from "hooks/useResendOtp";
import { usePermission } from "context/permission_context";

const OTPComponent = ({ setSteps, data, setData }) => {
  const { setPermission } = usePermission();
  const resendTextRef = useRef(null);
  const { canResend, resetTimer } = useResendOtp(resendTextRef);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Verify");
  const [otp, setOtp] = useState("");
  const [hasError, setHasError] = useState(false);

  const navigate = useNavigate();

  function mapMenuRoles(dataArray) {
    return dataArray.reduce((acc, item) => {
      acc[item.menuslug] = item.roles;
      return acc;
    }, {});
  }

  // Verify OTP Handler
  const verifyOtpHandler = async () => {
    try {
      if (!otp || otp.length < 5) {
        setHasError(true);
        return;
      }
      setHasError(false);
      setButtonLoader(true);

      const reqData = {
        email: data.email,
        otpType: "LOGIN",
        otp: otp,
      };

      const { data: responseData, status } = await verifyOtpApi(reqData);

      if (status === 200) {
        setPermission(mapMenuRoles(responseData?.data?.permission || []));
        localStorage.setItem(
          "cashsurvey_admin",
          JSON.stringify(responseData?.data.token)
        );
        localStorage.setItem(
          "admin-detail",
          JSON.stringify(responseData?.data.adminDetail)
        );
        localStorage.setItem(
          "admin-permission",
          JSON.stringify(mapMenuRoles(responseData?.data?.permission || []))
        );
        toastMessage(responseData?.message, "success", "loginToDashboard");
        navigate("/dashboard");
      }
    } catch (e) {
      console.log("error:", e.message);
    } finally {
      setButtonLoader(false);
    }
  };

  const handleOTPChange = (otpValue) => {
    setOtp(otpValue);
    setHasError(false);
  };

  // Resend OTP Handler
  const resendOtpHandler = async () => {
    try {
      const reqData = {
        email: data?.email,
      };
      const { data: responseData, status } = await resendOtp(reqData);
      if (status === 200) {
        resetTimer();
        setOtp("");
        toastMessage(responseData?.message, "success", "otpSend");
      }
    } catch (e) {
      console.log("error:", e.message);
    }
  };

  return (
    <>
      <div className="otp_section">
        <div className="form_title">
          <h2>Verify OTP</h2>
          <p>Please enter the OTP SENT to {data?.email}</p>
        </div>

        <div className="content">
          <div className="otp_wrap">
            <OTPInput
              inputStyle={"form-control input"}
              inputType="tel"
              value={otp}
              onChange={handleOTPChange}
              numInputs={5}
              renderInput={(props) => (
                <input
                  {...props}
                  style={{
                    ...props.style,
                    borderColor: hasError ? "#dc3545" : "initial", // Change border color on error
                    borderWidth: "2px",
                  }}
                />
              )}
            />
          </div>
          {hasError && <p className="onError">Please Enter OTP</p>}
          <div className="resend_button">
            {canResend ? (
              <p></p>
            ) : (
              <p>
                Resend OTP in <b ref={resendTextRef}></b>
              </p>
            )}
            <button
              type="button"
              disabled={!canResend}
              onClick={resendOtpHandler} // or the function to resend OTP when ready
            >
              Resend OTP
            </button>
          </div>
          <div className="button_wrap button_right">
            <button
              type="button"
              className="button w-100"
              ref={buttonLoader}
              // disabled={otp.length <= 4}
              onClick={verifyOtpHandler}
            >
              Verify
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OTPComponent;
